/**
 * Created by chenzheyu on 2017/6/16.
 */
import XksideMenus from './src/sideMenus.vue'

XksideMenus.install = function (Vue) {
  Vue.component(XksideMenus.name, XksideMenus)
}

export default XksideMenus



// WEBPACK FOOTER //
// ./src/components/module/sideMenus/index.js